import { c as _c } from "react/compiler-runtime";
import { LANG_LABELS, useLanguageSwitch } from "@repo/design-system/hooks/use-language-switch";
import { GlobeIcon } from "~/components/icons/globe-icon-eon";
import { useClientLocales } from "~/hooks/use-client-locales";
import { useLanguage } from "~/translations/loader/use-language";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger } from "./select-eon";
export function LanguageSwitcher() {
  const $ = _c(15);
  const t = useLanguage();
  const {
    value,
    onValueChange
  } = useLanguageSwitch();
  const locales = useClientLocales();
  if (locales.length <= 1) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <GlobeIcon className="size-6 hover:cursor-pointer" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.languageSwitcher_header) {
    t1 = <SelectTrigger aria-label={t.languageSwitcher_header} className="w-fit cursor-pointer border-none bg-background! text-base shadow-none" showIcon={false}>{t0}</SelectTrigger>;
    $[1] = t.languageSwitcher_header;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t.languageSwitcher_header) {
    t2 = <SelectLabel className="flex w-max flex-row items-center justify-center border-gray-200 border-b bg-white px-4 py-2 font-bold text-foreground text-lg"><span data-source="lc">{t.languageSwitcher_header}</span></SelectLabel>;
    $[3] = t.languageSwitcher_header;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== locales) {
    t3 = locales.map(_temp);
    $[5] = locales;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <SelectContent align="end"><SelectGroup>{t2}{t3}</SelectGroup></SelectContent>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onValueChange || $[11] !== t1 || $[12] !== t4 || $[13] !== value) {
    t5 = <Select onValueChange={onValueChange} value={value}>{t1}{t4}</Select>;
    $[10] = onValueChange;
    $[11] = t1;
    $[12] = t4;
    $[13] = value;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp(locale) {
  return <SelectItem className="focus:bg-primary focus:text-white" key={locale} value={locale}>{LANG_LABELS[locale]}</SelectItem>;
}